// removed by extract-text-webpack-plugin
module.exports = {"TrdResults":"TrdResults__-loca-__1_55w","ShufflingTitle":"TrdResults__-loca-__1wSSS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdAdminFocus/TrdResults/TrdResults.css
// module id = 211
// module chunks = 0